import React from "react";

import { useAppSelector } from "store";
import {
    chooseAllRetailMixSuperCategories,
    deselectAllRetailMixSuperCategories,
    selectRetailMixSuperCategories,
    toggleRetailMixSuperCategoryIsSelected
} from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";
import MultiSelectFilter from "components/filters/MultiSelectFilter";

const StoreCategoriesFilter: React.FC = () => {
    const storeCategories = useAppSelector(selectRetailMixSuperCategories);
    return (
        <MultiSelectFilter
            title="Store categories"
            allItemsChosenSubtitle="All categories"
            items={storeCategories}
            chooseAllItems={chooseAllRetailMixSuperCategories}
            deselectAllItems={deselectAllRetailMixSuperCategories}
            toggleItemIsSelected={toggleRetailMixSuperCategoryIsSelected}
        />
    );
};

export default StoreCategoriesFilter;
